import { Navigate, Outlet } from 'react-router-dom';

import { resolveLandingRoute, routes } from '@/config/routes';
import { useAuth } from '@/providers/auth-provider';

/** The `/` index branch (ADR-0028). The Dashboard is Super Admin / Admin only, but `/` is also the
 *  route every sign-in path navigates to — so instead of refusing, this sends each other role to
 *  the route the resolver says it belongs on.
 *
 *  Deliberately *not* `<RequireRole>`: landing on `/` is the app choosing a home for you, not a
 *  denial, so no access-denied toast fires here.
 *
 *  Loop-free by construction — the redirect only happens when the resolver did **not** choose the
 *  Dashboard, so `landing` can never be this route. */
export function RequireDashboardAccess() {
  const { user } = useAuth();
  const landing = resolveLandingRoute(user?.role);

  if (landing !== routes.dashboard) return <Navigate to={landing} replace />;
  return <Outlet />;
}
